var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bind-success-container" }, [
    _c("div", { staticClass: "decorative-top" }),
    _vm._v(" "),
    _c("div", { staticClass: "bind-success-card" }, [
      _c("h1", { staticClass: "title" }, [_vm._v("会员卡关联成功")]),
      _vm._v(" "),
      _c("p", { staticClass: "description" }, [
        _vm._v("\n      已成功绑定公众号"),
        _c("br"),
        _c("span", { staticClass: "highlight" }, [_vm._v(_vm._s(_vm.shop))])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "close-button", on: { click: _vm.returnMp } },
        [_vm._v("返回小程序")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5319908", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5319908","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bindmp/index.vue
// module id = null
// module chunks = 